export default __webpack_public_path__ + "static/0217-ad9e648633a96b2c2985f3be8e19e7dd.png";